/**
 * Get the class for the for group.
 *
 * @param  {Object} form      The form DOM element
 * @param  {String} fieldName The name of the field in the form group
 * @return {String}           The class name for the form group
 */
function getFormGroupClass(form, fieldName) {
    var field = form[fieldName];
    var status = "";

    if (field.$invalid && field.$dirty) {
        status = "has-error";
    }

    return status;
}

/**
 * Get the error for the form field.
 *
 * @param  {Object} form      The form DOM element
 * @param  {String} fieldName The name of the form field
 * @return {Object}           The field error
 */
function getFieldError(form, fieldName) {
    return form[fieldName].$error;
}

/**
 * Determine if the error message for the field should be displayed.
 *
 * @param  {Object} form      The form DOM element
 * @param  {String} fieldName The name of the form field
 * @return {Boolean}          True if the field error should be displayed; False otherwise
 */
function displayFieldError(form, fieldName) {
    var field = form[fieldName];
    var displayFieldError = false;

    if (field.$invalid && (field.$dirty || form.$submitted)) {
        displayFieldError = true;
    }

    return displayFieldError;
}

/**
 * Check if the form is valid.
 *
 * @param  {Object}  form The form DOM element
 * @return {Boolean}      True if the form is valid; False otherwise.
 */
function isFormValid(form) {
    return form.$valid;
}

/**
 * Validate the fields and update the dirty flag to trigger validation messages.
 *
 * @param  {Object}  form   The form DOM element
 * @param  {Array}   fields The fields to validate
 * @return {Boolean}        True if the fields are valid; False otherwise.
 */
function validateFields(form, fields) {
    var valid = true;

    if (!form || !fields) return false;

    angular.forEach(fields, function (fieldName) {
        if (form.hasOwnProperty(fieldName)) {
            if (!form[fieldName].$valid) {
                valid = false;
            }

            form[fieldName].$dirty = true;
        }
    });

    return valid;
}

/**
 * Check if the field is dirty (i.e. has been changed).
 *
 * @param  {Object}  form     The form DOM element
 * @param  {String} fieldName The name of the form field
 * @return {Boolean}          True if the field is dirty; False otherwise.
 */
function isDirty(form, fieldName) {
    return form[fieldName].$dirty;
}

/**
 * Check if the field is valid.
 *
 * @param  {Object}  form     The form DOM element
 * @param  {String} fieldName The name of the form field
 * @return {Boolean}          True if the field is valid; False otherwise.
 */
function isValid(form, fieldName) {
    return form[fieldName].$valid;
}

export default {
    getFormGroupClass: getFormGroupClass,
    getFieldError: getFieldError,
    displayFieldError: displayFieldError,
    isFormValid: isFormValid,
    validateFields: validateFields,
    isDirty: isDirty,
    isValid: isValid
};
